import { render, staticRenderFns } from "./FormLocalOcorrencia.vue?vue&type=template&id=2e678443&scoped=true&"
import script from "./FormLocalOcorrencia.vue?vue&type=script&lang=js&"
export * from "./FormLocalOcorrencia.vue?vue&type=script&lang=js&"
import style0 from "./FormLocalOcorrencia.vue?vue&type=style&index=0&id=2e678443&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e678443",
  null
  
)

export default component.exports